export default __webpack_public_path__ + "static/media/link.8c3ca3bf.svg";